// Popup Component
class Popup {
    constructor() {
        this.overlays = document.querySelectorAll('[id^="popup-overlay"]');
        this.triggerBtns = document.querySelectorAll('[data-popup-trigger]');
        this.currentPopup = null;
        
        this.init();
    }
    
    init() {
        if (this.overlays.length === 0) return;
        
        // Initialize all popups
        this.overlays.forEach(overlay => {
            this.initPopup(overlay);
        });
        
        // Add event listeners to all trigger buttons
        this.triggerBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const popupId = e.target.getAttribute('data-popup-trigger');
                this.open(popupId);
            });
        });
        
        // Close on Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.currentPopup) {
                this.close();
            }
        });
    }
    
    initPopup(overlay) {
        const closeBtn = overlay.querySelector('[data-popup-close]');
        const cancelBtn = overlay.querySelector('[data-popup-cancel]');
        const confirmBtn = overlay.querySelector('[data-popup-confirm]');
        
        // Close button
        closeBtn?.addEventListener('click', () => this.close());
        
        // Cancel button
        cancelBtn?.addEventListener('click', () => this.close());
        
        // Confirm button
        confirmBtn?.addEventListener('click', () => this.onConfirm(overlay));
        
        // Close on overlay click
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                this.close();
            }
        });
        
        // Set initial state
        overlay.style.display = 'flex';
        this.closePopup(overlay);
    }
    
    open(popupId) {
        const overlay = document.getElementById(`popup-overlay-${popupId}`);
        if (!overlay) return;
        
        // Close any currently open popup
        this.close();
        
        // Set current popup
        this.currentPopup = overlay;
        
        // Show popup with animation
        overlay.classList.add('active');
        
        // Prevent scroll
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        
        // GSAP animation if available
        if (typeof gsap !== 'undefined') {
            gsap.fromTo(overlay.querySelector('.popup-container'),
                {
                    scale: 0.8,
                    y: 20,
                    opacity: 0
                },
                {
                    scale: 1,
                    y: 0,
                    opacity: 1,
                    duration: 0.4,
                    ease: "back.out(1.7)"
                }
            );
        }
        
        // Trigger custom event
        overlay.dispatchEvent(new CustomEvent('popup:open', { detail: { popupId } }));
    }
    
    close() {
        if (!this.currentPopup) return;
        
        this.closePopup(this.currentPopup);
        this.currentPopup = null;
    }
    
    closePopup(overlay) {
        // GSAP animation if available
        if (typeof gsap !== 'undefined') {
            gsap.to(overlay.querySelector('.popup-container'),
                {
                    scale: 0.8,
                    y: 20,
                    opacity: 0,
                    duration: 0.3,
                    ease: "power2.in",
                    onComplete: () => {
                        overlay.classList.remove('active');
                        if (!this.currentPopup || this.currentPopup === overlay) {
                            this.restoreScroll();
                        }
                    }
                }
            );
        } else {
            overlay.classList.remove('active');
            if (!this.currentPopup || this.currentPopup === overlay) {
                this.restoreScroll();
            }
        }
        
        // Trigger custom event
        overlay.dispatchEvent(new CustomEvent('popup:close'));
    }
    
    restoreScroll() {
        // Restore scroll
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
    }
    
    isOpen() {
        return this.currentPopup?.classList.contains('active');
    }
    
    // Event handlers
    onConfirm(overlay) {
        // Trigger custom event
        overlay.dispatchEvent(new CustomEvent('popup:confirm'));
        this.close();
    }
    
    // Static method to create popup with custom options
    static create(options = {}) {
        const popup = new Popup();
        popup.open(options);
        return popup;
    }
}

// Auto-initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    window.popup = new Popup();
});

// Export for use in other modules
export default Popup;
